/* Keep marketing overlays out of cart use, without touching consent/payment UI. */
(() => {
 'use strict';
 const dismissed=new WeakSet();
 const viewport=window.visualViewport;
 const fitVisibleHeight=()=>{if(viewport)document.documentElement.style.setProperty('--occ-cart-height',Math.round(viewport.height)+'px');};
 viewport?.addEventListener('resize',fitVisibleHeight);fitVisibleHeight();
 const clearMarketing=()=>{
  if(document.body.dataset.occPage!=='cart'&&!document.querySelector('cart-drawer.active'))return;
  const close=document.querySelector('.react-responsive-modal-root .ecomsend__Modal__CloseButton');
  if(close&&!dismissed.has(close)){dismissed.add(close);close.click();}
 };
 new MutationObserver(clearMarketing).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['class']});
 clearMarketing();
})();
